import { useEffect, useRef, useState } from "react";

export default function useFormFeedback(errors, sessionKey) {
  const [touched, setTouched] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const inputs = useRef({});

  useEffect(() => {
    setTouched({});
    setSubmitted(false);
  }, [sessionKey]);

  const field = (name) => ({
    name,
    inputRef: (input) => { inputs.current[name] = input; },
    onBlur: () => setTouched((current) => ({ ...current, [name]: true })),
    error: touched[name] || submitted ? errors[name] : undefined,
  });

  const review = (onValid) => {
    setSubmitted(true);
    const firstError = Object.keys(errors)[0];
    if (firstError) {
      inputs.current[firstError]?.focus();
      return;
    }
    onValid();
  };

  return { field, review };
}
